/**
 *
 * Checkout
 *
 */
import '../UnionRepresentative/styles.css';
import { Button, Col, Form, Row, Select, Upload, UploadFile } from 'antd';
import { ReactComponent as CloseIcon } from 'app/assets/img/close_icon.svg';
import { CheckoutOrderOverview } from 'app/components/CheckoutOrderOverview';
import { LoadingContainer } from 'app/components/LoadingContainer';
import ModalContainer from 'app/components/ModalContainer';
import StyledButton from 'app/components/StyledButton';
import React, { memo, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { selectInfoUser, selectTranslations } from '../App/slice/selectors';
import { useUpdateTicketInfo } from './hooks/useUpdateTicketInfo';
import { CheckoutWrapper } from './styled';
import {
  AddFieldContainer,
  CustomSelect,
  Description,
  FormContainer,
  HeaderContainer,
  Title,
} from '../UnionRepresentative/styled';
import CustomInput from '../UnionRepresentative/components/ImputCustom';
import { TGroupRepresentative } from '../UnionRepresentative/types';
import _ from 'lodash';
import PlusIcon from '../UnionRepresentative/icon/PlusIcon';
import { POSITION } from '../UnionRepresentative/constants';
import { updateCheckoutPaymentApi } from 'app/services/checkoutApi';
import { useGlobalFunction } from '../App/hooks/useGlobalFunction';
import { flushSync } from 'react-dom';
import useWindowSize from 'app/hooks/useWindowSize';
import NotFound from '../NotFound';
import RenderIf from 'app/components/RenderIf';
import useFetchData from 'app/hooks/useFetchData';
import { getBusinessPartnerApi } from 'app/services/agentApi';
import { StyledUpload } from '../UnionRepresentative';
import { ReactComponent as RedTrashIcon } from 'app/assets/img/close_icon.svg';
import { ReactComponent as RedMinusIcon } from 'app/assets/img/close_icon.svg';
import { convertVItoEN } from '../NewAccount/CheckTickets/helper';
const { Option } = Select;

export const UpdateTicketInfo = memo(() => {
  const history = useHistory();
  const { onOpenDialogNoti, onCloseDialogNoti } = useGlobalFunction();
  const location = useLocation<any>();
  const prevPage = location.state?.prevPage;
  const search = new URLSearchParams(location?.search);
  const orderId = search.get('order_id');
  const infoUser = useSelector(selectInfoUser);
  const [requireFields, setRequireFields] = useState<boolean[]>([]);

  const translations = useSelector(selectTranslations);
  const dispatch = useDispatch();

  const {
    totalAmount,
    totalPriceOriginal,
    totalPrice,
    setEnableConfirm,
    orderCheckout,
    enableConfirm,
    totalDiscount,
    groupCart,
    vouchers,
    listCart,
    idOrder,
    mailTaxs,
    representativesInfo,
    businessPartner: businessPartnerData,
    orderDetail,
  } = useUpdateTicketInfo();

  const userInfo = useSelector(selectInfoUser);
  const emailBpAllocatedDebt = orderDetail?.emailBpAllocatedDebt;

  const getAllocatedDebtPayload = useMemo(() => {
    return {
      bpAllocatedDebt: orderDetail?.businessPartnerAllocatedDebt?.id,
    };
  }, [orderDetail?.businessPartnerAllocatedDebt?.id]);

  const { result: allocatedDebtData } = useFetchData({
    actionApi: getBusinessPartnerApi,
    payloadData: getAllocatedDebtPayload,
    IIFE: !!emailBpAllocatedDebt,
  });

  const businessPartner = !!emailBpAllocatedDebt
    ? allocatedDebtData
    : businessPartnerData;

  const mailReceiveTicketListOfBpAllocatedDebt = useMemo(
    () => [
      ...new Set([
        ...(allocatedDebtData?.emailAgents ?? []),
        ...(allocatedDebtData?.extraInfo?.email ?? []),
      ]),
    ],
    [allocatedDebtData?.emailAgents, allocatedDebtData?.extraInfo?.email],
  );

  const isNoEmptyAllocatedDebt =
    mailReceiveTicketListOfBpAllocatedDebt.length > 0;

  const mailReceiveTicketList = useMemo(() => {
    if (!emailBpAllocatedDebt) return [];
    if (isNoEmptyAllocatedDebt) return mailReceiveTicketListOfBpAllocatedDebt;
    return [userInfo?.username];
  }, [
    emailBpAllocatedDebt,
    isNoEmptyAllocatedDebt,
    mailReceiveTicketListOfBpAllocatedDebt,
    userInfo?.username,
  ]);

  const handleValuesChange = (_, allValues) => {
    if (!Array.isArray(allValues.representatives)) return;

    setRequireFields(
      allValues.representatives.map(rep =>
        Object.values(rep).some(value => value),
      ),
    );
  };

  const emailCanBeEdit = useMemo(() => {
    return mailTaxs.map((ele, index) => ele);
  }, [mailTaxs]);

  const defaultEmail = useMemo(() => {
    return _.isEmpty(businessPartner?.extraInfo?.email) ||
      !_.isArray(businessPartner?.extraInfo?.email)
      ? []
      : businessPartner?.extraInfo?.email.map(
          (ele: string, index: number) => ele,
        );
  }, [businessPartner]);

  const currentEmails = useMemo(() => {
    return [...defaultEmail, ...emailCanBeEdit];
  }, [businessPartner, defaultEmail]);

  const { device } = useWindowSize();
  const [form] = Form.useForm();

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const handleNavigateToPayment = () => {
    flushSync(() => {
      setEnableConfirm(false);
    });
    history.push(`/checkout/${orderId}`);
  };

  const handleUpdateTicketInfo = async (values: any) => {
    setIsLoading(true);
    const formData = new FormData();

    formData.append('idHash', `${orderCheckout.current?.idHash ?? ''}`);
    if (!_.isNil(emailBpAllocatedDebt))
      formData.append(
        'emailBpAllocatedDebt',
        form.getFieldValue('emailBpAllocatedDebt'),
      );

    if (!_.isNil(values?.['approvedCode']) && values?.['approvedCode'] !== '')
      formData.append(`approvedCode`, values?.['approvedCode']);

    if (!!values.approveAttach && !!values.approveAttach?.length) {
      if (
        JSON.stringify(values.approveAttach) !==
        JSON.stringify(originApproveAttach.current)
      ) {
        formData.append(
          'approveAttach',
          values.approveAttach?.[0]?.originFileObj,
        );
      }
    } else {
      formData.append('approveAttach', 'null');
    }

    values?.emails
      ?.filter(ele => !(defaultEmail || []).includes(ele))
      ?.forEach((email: string, index: number) => {
        formData.append(`emailTax[${index}]`, email);
      });

    values?.representatives?.forEach(
      (rep: TGroupRepresentative, index: number) => {
        if (requireFields[index]) {
          formData.append(`representatives[${index}][name]`, rep.name);
          formData.append(`representatives[${index}][phone]`, rep.phone);
          formData.append(`representatives[${index}][email]`, rep.email || '');
          formData.append(`representatives[${index}][position]`, rep.position);
        }
      },
    );

    try {
      await updateCheckoutPaymentApi(formData);
      if (prevPage === 'EDIT_ORDER') {
        handleNavigateToPayment();
        return;
      }
      onOpenDialogNoti({
        type: 'SUCCESS',
        isShow: true,
        title: translations?.['b2b.txt.update-info-success'] ?? '',
        content: '',
        closable: false,
        buttons: [
          {
            text: translations?.['b2b.btn.confirm'] ?? '',
            bg: 'linear-gradient(79.97deg, #F06F24 -7.79%, #F8B117 107.61%)',
            color: 'white',
            onClick: () => {
              onCloseDialogNoti();
              history.goBack();
            },
          },
        ],
        maskClosable: false,
      });
    } catch (error: any) {
      const errCode = error?.data?.code;
      if (errCode === 'MSG022') {
        onOpenDialogNoti({
          type: 'ERROR',
          isShow: true,
          title: error?.message ?? '',
          content: '',
          onCloseDialog: () => {
            onCloseDialogNoti();
            flushSync(() => {
              setEnableConfirm(false);
            });
            history.push('/account', {
              targetTab: 'tab-3',
            });
          },
          buttons: [],
          maskClosable: false,
          closable: true,
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (businessPartner) {
      form.setFieldsValue({
        emails: currentEmails,
        representatives: representativesInfo.map(
          (item: TGroupRepresentative, index: number) => ({
            email: item?.email,
            name: item?.name,
            phone: item?.phone,
            position: item?.position,
          }),
        ),
      });
    }
  }, [businessPartner, representativesInfo, form]);

  useEffect(() => {
    if (orderCheckout?.current?.agent?.id && infoUser?.id) {
      setIsLoading(false);
    }
  }, [orderCheckout?.current?.agent?.id, infoUser?.id]);

  useEffect(() => {
    form.setFieldValue('emailBpAllocatedDebt', emailBpAllocatedDebt);
  }, [form, emailBpAllocatedDebt]);

  useEffect(() => {
    form.setFieldValue('approvedCode', orderDetail?.approvedCode);
  }, [form, orderDetail?.approvedCode]);

  const originApproveAttach = useRef<Record<string, any>[]>();

  useEffect(() => {
    const setApproveAttachDocs = () => {
      const approveAttach = orderDetail?.approveAttach;
      if (!approveAttach) return;
      const fileList: UploadFile[] = [
        {
          uid: '-1',
          name: approveAttach,
          status: 'done',
          url: approveAttach,
        },
      ];
      originApproveAttach.current = fileList;
      form.setFieldsValue({ approveAttach: fileList });
    };

    setApproveAttachDocs();
  }, [form, orderDetail?.approveAttach]);

  const beforeUploadApprovalDocs = (file: File) => {
    const allowedTypes = [
      'application/pdf',
      'application/msword', // .doc
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
      'application/vnd.ms-excel', // .xls
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
      'message/rfc822', // .eml
    ];

    if (!allowedTypes.includes(file.type)) {
      onOpenDialogNoti({
        type: 'ERROR',
        title: translations?.['b2b.txt.uploadApprovalDocumentType'] ?? '',
        content: '',
        isShow: true,
        buttons: [],
        maskClosable: false,
        closable: true,
        onCloseDialog: onCloseDialogNoti,
      });
      return Upload.LIST_IGNORE;
    }

    if (file.size / 1024 / 1024 > 5) {
      onOpenDialogNoti({
        type: 'ERROR',
        title: translations?.['b2b.txt.uploadApprovalDocumentSize'] ?? '',
        content: '',
        isShow: true,
        buttons: [],
        maskClosable: false,
        closable: true,
        onCloseDialog: onCloseDialogNoti,
      });
      return Upload.LIST_IGNORE;
    }

    return false;
  };

  return (
    <RenderIf
      condition={
        isLoading || orderCheckout?.current?.agent?.id === infoUser?.id
      }
      fallback={<NotFound />}
      children={
        <CheckoutWrapper id="bookticketspay" className="main">
          <div className="bookticketspayContent bookticketsContent checkOut">
            <div className="container">
              <LoadingContainer isFullPage loading={isLoading}>
                <Form
                  form={form}
                  onValuesChange={handleValuesChange}
                  onFinish={handleUpdateTicketInfo}
                  initialValues={{
                    emails: currentEmails,
                    representatives: [
                      { name: '', phone: '', email: '', position: '' },
                    ],
                  }}
                  validateMessages={{
                    required:
                      '${label} ' +
                      (translations
                        ? translations['b2b.form.validate-require']
                        : ''),
                    string: {
                      len: '${label} phải có ${len} kí tự',
                      min:
                        '${label} ' +
                        (translations
                          ? translations['b2b.form.validate-min-chars-1']
                          : '') +
                        ' ${min} ' +
                        (translations
                          ? translations['b2b.form.validate-chars']
                          : ''),
                      max:
                        '${label} ' +
                        (translations
                          ? translations['b2b.form.validate-max-chars-1']
                          : '') +
                        ' ${max} ' +
                        (translations
                          ? translations['b2b.form.validate-chars']
                          : ''),
                      range: '${label} must be between ${min} and ${max} kí tự',
                    },
                    types: {
                      email:
                        '${label} ' +
                        (translations ? translations['b2b.form.invalid'] : ''),
                      number:
                        '${label}: ${type} ' +
                        (translations ? translations['b2b.form.invalid'] : ''),
                      string:
                        '${label}: ${type} ' +
                        (translations ? translations['b2b.form.invalid'] : ''),
                      date:
                        '${label}: ${type} ' +
                        (translations ? translations['b2b.form.invalid'] : ''),
                      method:
                        '${label}: ${type} ' +
                        (translations ? translations['b2b.form.invalid'] : ''),
                      array:
                        '${label}: ${type} ' +
                        (translations ? translations['b2b.form.invalid'] : ''),
                      object:
                        '${label}: ${type} ' +
                        (translations ? translations['b2b.form.invalid'] : ''),
                      boolean:
                        '${label}: ${type} ' +
                        (translations ? translations['b2b.form.invalid'] : ''),
                      integer:
                        '${label}: ${type} ' +
                        (translations ? translations['b2b.form.invalid'] : ''),
                      float:
                        '${label}: ${type} ' +
                        (translations ? translations['b2b.form.invalid'] : ''),
                      regexp:
                        '${label}: ${type} ' +
                        (translations ? translations['b2b.form.invalid'] : ''),
                      url:
                        '${label}: ${type} ' +
                        (translations ? translations['b2b.form.invalid'] : ''),
                      hex:
                        '${label}: ${type} ' +
                        (translations ? translations['b2b.form.invalid'] : ''),
                    },
                    number: {
                      len: '${label} must equal ${len}',
                      min: '${label} cannot be less than ${min}',
                      max: '${label} cannot be greater than ${max}',
                      range: '${label} must be between ${min} and ${max}',
                    },
                    array: {
                      len: '${label} must be exactly ${len} in length',
                      min: '${label} cannot be less than ${min} in length',
                      max: '${label} cannot be greater than ${max} in length',
                      range:
                        '${label} must be between ${min} and ${max} in length',
                    },
                    pattern: {
                      mismatch: '${label} does not match pattern ${pattern}',
                    },
                    enum: '${label} must be one of [${enum}]',
                    whitespace: '${label} cannot be empty',
                    date: {
                      format: '${label} is invalid for format date',
                      parse: '${label} could not be parsed as date',
                      invalid: '${label} is invalid date',
                    },
                  }}
                >
                  <div className="row">
                    <div className="col-xl-8">
                      <div className="checkOutInfo">
                        {/* Thông tin xuất hóa đơn */}
                        <HeaderContainer style={{ justifyContent: 'start' }}>
                          <Title>
                            {translations
                              ? translations['b2b.txt.invoice-export-title']
                              : ''}
                          </Title>
                        </HeaderContainer>
                        <Description style={{ fontStyle: 'italic' }}>
                          {translations
                            ? translations['b2b.txt.invoice-export-description']
                            : ''}
                        </Description>
                        <FormContainer
                          style={
                            device === 'mobile'
                              ? {
                                  display: 'block',
                                }
                              : {}
                          }
                        >
                          <Form.Item
                            style={
                              device === 'mobile'
                                ? {
                                    marginBottom: '8px',
                                  }
                                : {}
                            }
                          >
                            <CustomInput
                              placeholder={
                                translations?.['b2b.txt.invoice-code']
                              }
                              disabled
                              value={businessPartner?.extraInfo?.taxNumber}
                            />
                          </Form.Item>
                          <Form.Item
                            style={
                              device === 'mobile'
                                ? {
                                    marginBottom: '8px',
                                  }
                                : {}
                            }
                          >
                            <CustomInput
                              placeholder={
                                translations?.[
                                  'b2b.txt.stateBudgetRelatedUnitCode'
                                ]
                              }
                              disabled
                              value={businessPartner?.extraInfo?.stateBudget}
                            />
                          </Form.Item>
                          <Form.Item
                            style={
                              device === 'mobile'
                                ? {
                                    marginBottom: '8px',
                                  }
                                : {}
                            }
                          >
                            <CustomInput
                              placeholder={
                                translations?.['b2b.txt.invoice-export-title']
                              }
                              disabled
                              value={businessPartner?.baseInfo?.name}
                            />
                          </Form.Item>
                          <Form.Item
                            style={
                              device === 'mobile'
                                ? {
                                    marginBottom: '8px',
                                  }
                                : {}
                            }
                          >
                            <CustomInput
                              placeholder={translations?.['b2b.form.address']}
                              disabled
                              value={businessPartner?.baseInfo?.address}
                            />
                          </Form.Item>

                          {/* Emails */}
                          <Form.List name="emails">
                            {(fields, { add, remove }) => (
                              <>
                                {fields.map((field, index) => {
                                  const isInitialEmail =
                                    defaultEmail && !!defaultEmail[index];

                                  return (
                                    <div
                                      key={field.key}
                                      style={{ display: 'flex' }}
                                    >
                                      <Form.Item
                                        {...field}
                                        rules={
                                          !isInitialEmail
                                            ? [
                                                {
                                                  required: true,
                                                  type: 'email',
                                                },
                                              ]
                                            : []
                                        }
                                        style={
                                          device === 'mobile'
                                            ? {
                                                marginBottom: '8px',
                                                flex: 1,
                                              }
                                            : { flex: 1 }
                                        }
                                        className="form-item-class"
                                        label={translations?.['b2b.acc.email']}
                                      >
                                        <CustomInput
                                          disabled={isInitialEmail}
                                          placeholderCustom={
                                            translations?.['b2b.acc.email']
                                          }
                                        />
                                      </Form.Item>
                                      {!isInitialEmail && (
                                        <button
                                          onClick={() => remove(field.name)}
                                          style={{
                                            cursor: 'pointer',
                                            backgroundColor: 'white',
                                            border: 0,
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                          }}
                                        >
                                          <RedMinusIcon />
                                        </button>
                                      )}
                                    </div>
                                  );
                                })}
                                <AddFieldContainer
                                  style={{
                                    gridColumn: 'span 2',
                                    lineHeight: '20px',
                                  }}
                                >
                                  <div onClick={() => add()}>
                                    <PlusIcon />{' '}
                                    {translations
                                      ? translations[
                                          'b2b.txt.add-invoice-receipt-email'
                                        ]
                                      : ''}
                                  </div>
                                </AddFieldContainer>
                              </>
                            )}
                          </Form.List>
                        </FormContainer>

                        {!!emailBpAllocatedDebt && (
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'start',
                              margin: '50px 0px 10px 0px',
                            }}
                          >
                            <HeaderContainer
                              style={{
                                justifyContent: 'start',
                                marginTop: '36px',
                                margin: 0,
                              }}
                            >
                              <Title>
                                {translations
                                  ? translations['b2b.txt.ticketReceiptInfo']
                                  : ''}
                              </Title>
                            </HeaderContainer>

                            <Row
                              style={{
                                width: '100%',
                                marginTop: 16,
                              }}
                              gutter={[24, 8]}
                            >
                              <Col span={device === 'mobile' ? 24 : 12}>
                                <Form.Item
                                  name={'emailBpAllocatedDebt'}
                                  rules={[{ required: true }]}
                                  className="form-item-class"
                                  label={translations?.['b2b.acc.email'] ?? ''}
                                  style={{ marginBottom: 0 }}
                                >
                                  <CustomSelect
                                    style={{
                                      borderBottom: '1px solid #C1C1C1',
                                      paddingBottom: '7px',
                                    }}
                                    placeholder={
                                      translations
                                        ? translations['b2b.acc.email'] + '*'
                                        : ''
                                    }
                                    onBlur={() => {
                                      form.validateFields([
                                        'emailBpAllocatedDebt',
                                      ]);
                                    }}
                                    filterOption={(input, option) =>
                                      (
                                        convertVItoEN(option?.children) ?? ''
                                      ).includes(convertVItoEN(input))
                                    }
                                    showSearch
                                  >
                                    {mailReceiveTicketList.map(item => (
                                      <Option key={item} value={item}>
                                        {item}
                                      </Option>
                                    ))}
                                  </CustomSelect>
                                </Form.Item>
                              </Col>

                              <Col span={device === 'mobile' ? 24 : 12}>
                                <Form.Item
                                  name={'approvedCode'}
                                  className="form-item-class"
                                  label={translations?.['b2b.acc.email'] ?? ''}
                                  style={{ marginBottom: 0 }}
                                >
                                  <CustomInput
                                    maxLength={190}
                                    placeholder={
                                      translations?.['b2b.txt.approvalCode'] ??
                                      ''
                                    }
                                  />
                                </Form.Item>
                              </Col>

                              <Col span={device === 'mobile' ? 24 : 12}>
                                <Form.Item
                                  name={'approveAttach'}
                                  valuePropName="fileList"
                                  getValueFromEvent={e => e && e.fileList}
                                  className="form-item-class"
                                  style={{ marginBottom: 0 }}
                                >
                                  <StyledUpload
                                    beforeUpload={beforeUploadApprovalDocs}
                                    action={undefined}
                                    multiple={false}
                                    maxCount={1}
                                  >
                                    <Button
                                      style={{
                                        color: '#F8B117',
                                        border: 'none',
                                      }}
                                    >
                                      {translations?.[
                                        'b2b.txt.uploadApprovalDocument'
                                      ] ?? ''}
                                    </Button>
                                  </StyledUpload>
                                </Form.Item>
                              </Col>
                            </Row>
                          </div>
                        )}

                        {/* Representatives */}
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            margin: '50px 0px 10px 0px',
                          }}
                        >
                          <HeaderContainer
                            style={{
                              justifyContent: 'start',
                              marginTop: '36px',
                              margin: 0,
                            }}
                          >
                            <Title>
                              {translations
                                ? translations['b2b.txt.representiveInfo']
                                : ''}
                            </Title>
                          </HeaderContainer>
                        </div>
                        <Form.List name="representatives">
                          {(fields, { add, remove }) => (
                            <>
                              {fields.map((field, index) => (
                                <div
                                  key={field.key}
                                  style={{ margin: '20px 0 16px 0px' }}
                                >
                                  <p
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      fontWeight: 600,
                                      fontSize: '16px',
                                    }}
                                  >
                                    {translations
                                      ? translations[
                                          'b2b.txt.contactType.representative'
                                        ]
                                      : ''}{' '}
                                    {index + 1}
                                    {index !== 0 && (
                                      <button
                                        onClick={() => remove(field.name)}
                                        style={{
                                          cursor: 'pointer',
                                          border: '0px solid #C1C1C1',
                                          borderRadius: '5px',
                                          backgroundColor: 'white',
                                          display: 'flex',
                                          justifyContent: 'center',
                                          alignItems: 'center',
                                        }}
                                      >
                                        <RedTrashIcon />
                                      </button>
                                    )}
                                  </p>
                                  <FormContainer
                                    style={
                                      device === 'mobile'
                                        ? {
                                            display: 'block',
                                          }
                                        : {}
                                    }
                                  >
                                    <Form.Item
                                      {...field}
                                      name={[field.name, 'name']}
                                      rules={[
                                        {
                                          max: 190,
                                          required: requireFields[index],
                                        },
                                      ]}
                                      style={
                                        device === 'mobile'
                                          ? {
                                              marginBottom: '8px',
                                            }
                                          : {}
                                      }
                                      className="form-item-class"
                                      label={
                                        translations?.[
                                          'b2b.form.namePlaceholder'
                                        ]
                                      }
                                    >
                                      <CustomInput
                                        maxLength={190}
                                        placeholder={
                                          translations?.[
                                            'b2b.form.namePlaceholder'
                                          ]
                                        }
                                      />
                                    </Form.Item>
                                    <Form.Item
                                      {...field}
                                      name={[field.name, 'phone']}
                                      rules={[
                                        { required: requireFields[index] },
                                        { min: 10 },
                                        { max: 20 },
                                        {
                                          pattern: /^[0-9]+$/g,
                                          message:
                                            translations?.[
                                              'b2b.form.wrongPhoneFormat'
                                            ] ?? '',
                                        },
                                        ({ getFieldValue }) => ({
                                          validator(_, value) {
                                            if (!value) {
                                              return Promise.resolve();
                                            } else {
                                              const phones = getFieldValue(
                                                'representatives',
                                              )
                                                .map((rep: any) => rep.phone)
                                                .filter(
                                                  (phone: string) => !!phone,
                                                );

                                              const duplicateCount =
                                                phones.filter(
                                                  (phone: string) =>
                                                    phone === value,
                                                ).length;
                                              if (duplicateCount > 1) {
                                                return Promise.reject(
                                                  new Error(
                                                    translations?.[
                                                      'b2b.txt.phone-duplicate'
                                                    ],
                                                  ),
                                                );
                                              }
                                              return Promise.resolve();
                                            }
                                          },
                                        }),
                                      ]}
                                      style={
                                        device === 'mobile'
                                          ? {
                                              marginBottom: '8px',
                                            }
                                          : {}
                                      }
                                      className="form-item-class"
                                      label={translations?.['b2b.acc.phone']}
                                    >
                                      <CustomInput
                                        maxLength={20}
                                        onlyNumber
                                        placeholder={
                                          translations?.['b2b.acc.phone']
                                        }
                                      />
                                    </Form.Item>
                                    <Form.Item
                                      {...field}
                                      name={[field.name, 'email']}
                                      rules={[{ max: 200 }, { type: 'email' }]}
                                      style={
                                        device === 'mobile'
                                          ? {
                                              marginBottom: '8px',
                                            }
                                          : {}
                                      }
                                      className="form-item-class"
                                      label={translations?.['b2b.acc.email']}
                                    >
                                      <CustomInput
                                        maxLength={200}
                                        placeholder={
                                          translations?.['b2b.acc.email']
                                        }
                                      />
                                    </Form.Item>
                                    <Form.Item
                                      {...field}
                                      name={[field.name, 'position']}
                                      rules={[
                                        { required: requireFields[index] },
                                      ]}
                                      style={
                                        device === 'mobile'
                                          ? {
                                              marginBottom: '8px',
                                            }
                                          : {}
                                      }
                                      className="form-item-class"
                                      label={
                                        translations
                                          ? translations['b2b.txt.position']
                                          : ''
                                      }
                                    >
                                      <CustomSelect
                                        style={{
                                          borderBottom: '1px solid #C1C1C1',
                                          paddingBottom: '7px',
                                        }}
                                        placeholder={
                                          translations
                                            ? translations['b2b.txt.position']
                                            : ''
                                        }
                                      >
                                        {POSITION.map(item => (
                                          <Option key={item.id} value={item.id}>
                                            {translations?.[item.label]}
                                          </Option>
                                        ))}
                                      </CustomSelect>
                                    </Form.Item>
                                  </FormContainer>
                                </div>
                              ))}
                              <AddFieldContainer>
                                <div
                                  onClick={() =>
                                    add({
                                      name: '',
                                      phone: '',
                                      email: '',
                                      position: null,
                                    })
                                  }
                                >
                                  <PlusIcon />{' '}
                                  {translations
                                    ? translations[
                                        'b2b.txt.add-a-group-representative'
                                      ]
                                    : ''}
                                </div>
                              </AddFieldContainer>
                            </>
                          )}
                        </Form.List>
                      </div>
                    </div>
                    <div className="col-xl-4">
                      <CheckoutOrderOverview
                        vouchers={vouchers}
                        headerText={`${
                          translations?.['b2c.txt.order'] ?? ''
                        }: ${idOrder ?? ''}`}
                        isDisableCountDown={true}
                        listCart={listCart}
                        orderCheckoutRef={orderCheckout}
                        isHideButton={false}
                        listGroupCart={groupCart}
                        totalAmount={totalAmount}
                        totalDiscount={totalDiscount}
                        totalPrice={totalPrice}
                        totalPriceOriginal={totalPriceOriginal}
                        onTimeout={() => {
                          setEnableConfirm(false);
                        }}
                        actionButton={
                          <div className="d-flex mt-3 justify-content-between">
                            <div
                              className="d-flex justify-content-between align-items-center mr-2"
                              style={{ flex: 1, marginRight: 7 }}
                            >
                              <StyledButton
                                textColor="#808080"
                                bgColor="white"
                                style={{ flex: 1 }}
                                border="1px solid #808080"
                                onClick={() => {
                                  history.goBack();
                                }}
                              >
                                <i className="fa-solid fa-arrow-left"></i>
                                <span
                                  className="--textBtn"
                                  style={{
                                    marginLeft: 8,
                                  }}
                                >
                                  {translations
                                    ? translations['b2c.txt.back']
                                    : ''}
                                </span>
                              </StyledButton>
                            </div>
                            <div
                              className="d-flex justify-content-between align-items-center"
                              style={{ flex: 1, marginLeft: 7 }}
                            >
                              <StyledButton
                                htmlType="submit"
                                style={{ flex: 1, width: 'auto' }}
                                textColor="white"
                              >
                                <span
                                  className="--textBtnNext"
                                  style={{
                                    marginRight: 8,
                                  }}
                                >
                                  {translations?.[
                                    prevPage === 'EDIT_ORDER'
                                      ? 'b2b.txt.continue'
                                      : 'b2b.txt.confirm-update-info'
                                  ] ?? ''}
                                </span>
                                <i className="fa-solid fa-arrow-right"></i>
                              </StyledButton>
                            </div>
                          </div>
                        }
                        onGoBack={() => {
                          history.goBack();
                        }}
                        onCheckout={() => {}}
                      />
                    </div>
                  </div>
                </Form>
              </LoadingContainer>
            </div>
          </div>
        </CheckoutWrapper>
      }
    />
  );
});
